import { h } from '@stencil/core';
import cn from 'classnames';
import { isSVG, isUrl } from '@pes-ui/utils';
import { ItemType } from '../utils';
import PlayIcon from '../icons/play.svg';
export const ThumbnailItem = ({ item, label, active, handleMouseEnter, handleClick, }) => {
  const isSmall = (item.type === ItemType.IMG
    && !item.isMainImage
    && isSVG(item.thumbnail));
  const imageAsUrl = isUrl(item.thumbnail || item.preview);
  return (h("div", { class: "thumbnails__item" }, h("div", { class: cn('thumbnails__item-content', {
      'thumbnails__item-content--active': active,
    }), onMouseEnter: handleMouseEnter, onClick: handleClick }, item.type !== ItemType.VIDEO && imageAsUrl && (h("img", { loading: "lazy", src: item.thumbnail || item.preview, alt: item.title, class: cn('thumbnails__item-image', {
      'thumbnails__item-image--small': isSmall,
    }) })), item.type !== ItemType.VIDEO && (item === null || item === void 0 ? void 0 : item.thumbnail) && !imageAsUrl && (h("pes-custom-qds-icon", { iconName: item.thumbnail, customClasses: "thumbnails__qds-icon" })), handleClick && (h("div", { class: "thumbnails__item--cta" }, item.type === ItemType.VIDEO ? (h("div", { class: "thumbnails__item-icon", innerHTML: PlayIcon })) : (h("div", { class: "thumbnails__item-label" }, item.title))))), item.type === 'video' && (h("div", { class: "thumbnails__item-label thumbnails__item-label--small" }, label))));
};
